import { Theme } from '@mui/material';
import { grey } from '@mui/material/colors';

import config from '../../config';

const Paper = (theme: Theme) => {
  return {
    MuiPaper: {
      defaultProps: {
        elevation: config.theme.elevation,
      },
      variants: [{
        props: { variant: 'elevation' },
        style: {
          borderColor: '#000',
          borderStyle: 'solid',
          borderWidth: 2,
          boxShadow: '-5px 5px 0 #000',
          borderRadius: 16,
        },
      }, {
        props: { variant: 'elevation', elevation: 0 },
        style: {
          boxShadow: 'none',
          borderRadius: 0,
        },
      }, {
        props: { variant: 'outlined' },
        style: {
          borderColor: grey[200],
          borderStyle: 'solid',
          borderWidth: 2,
        },
      }],
    },
  };
};

export default Paper;
